import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ArrowNarrowLeftIcon } from '@heroicons/react/solid';
import {
  Col,
  Row,
  Form,
  Card,
  Button,
  Container,
  InputGroup,
  Collapse,
  Spinner,
  Alert,
} from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { ErrorAlert } from '#atoms';
import { authForgotPassword } from '#store/actions/authActions';
import { Routes } from '#Routes';

const ForgotPasswordPage = () => {
  const { t } = useTranslation();
  const { error } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { isSubmitSuccessful, isSubmitting },
  } = useForm();
  const isSuccess = isSubmitSuccessful && !error?.length;

  const onFormSubmit = async (data) => {
    await dispatch(authForgotPassword(data));
  };

  return (
    <main>
      <section className='vh-lg-100 mt-5 mt-lg-0 bg-soft d-flex align-items-center'>
        <Container>
          <Row className='justify-content-center'>
            <p className='text-center'>
              <Card.Link
                as={Link}
                to={Routes.Login.path}
                className='d-flex align-items-center justify-content-center'
              >
                <ArrowNarrowLeftIcon className='icon icon-xs me-2' />
                {t('auth.backToHomepage')}
              </Card.Link>
            </p>
            <Col xs={12} className='d-flex align-items-center justify-content-center'>
              <div className='signin-inner my-3 my-lg-0 bg-white shadow border-0 rounded p-4 p-lg-5 w-100 fmxw-500'>
                <h3>{t('auth.forgotYourPassword')}</h3>
                <p className='mb-4'>{t('auth.forgotPasswordCode')}</p>
                <Form onSubmit={handleSubmit(onFormSubmit)}>
                  <div className='mb-4'>
                    <Form.Label htmlFor='email'>{t('auth.email')}</Form.Label>
                    <InputGroup id='email'>
                      <Form.Control
                        autoFocus
                        type='email'
                        placeholder='john@company.com'
                        autoComplete='email'
                        {...register('email', { required: true })}
                      />
                    </InputGroup>
                  </div>

                  {isSuccess && (
                    <Collapse in={true} appear={true}>
                      <div className='d-grid'>
                        <Alert variant='success'>{t(`auth.recoverPasswordSuccessPrompt`)}</Alert>
                      </div>
                    </Collapse>
                  )}

                  {!isSuccess && (
                    <>
                      {isSubmitSuccessful && <ErrorAlert error={error} />}

                      <div className='d-grid'>
                        <Button variant='primary' size='lg' type='submit' disabled={isSubmitting}>
                          {isSubmitting ? <Spinner size='sm' /> : t('auth.recoverPassword')}
                        </Button>
                      </div>
                    </>
                  )}
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};

export default ForgotPasswordPage;
